module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/json/stringify.js
// module id = 1672
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 20 21